/*=========================================================================================
  File Name: mutations.js
  Namespace: lpaths
  Description: Vuex Store - Learning Path mutations
==========================================================================================*/
import {
  buildLPathState
} from './state'

const mutations = {
  STORE_CURRENT_LPATH(state, lpath) {
    state.currentLPath = { ...state.currentLPath, ...lpath }
    state.currentLPath = {
      ...state.currentLPath,
      ...lpath,
      categories: lpath.categories ? lpath.categories : [],
      learning_areas: lpath.learning_areas ? lpath.learning_areas : []
    };
  },
  RESET_CURRENT_LPATH(state) {
    state.currentLPath = buildLPathState()
  },
  STORE_LIST_LPATHS(state, lpaths) {
    state.lpathList = {
      ...state.lpathList,
      ...lpaths.entries
    }
    state.count = lpaths.count
    state.next = lpaths.next
    state.previous = lpaths.previous
    state.results = [...lpaths.results]
  },
  RESET_CURRENT_LPATH_CONTENT(state) {
    state.currentLPath.content = [];
  },
  ADD_LEAF_TO_STRUCTURE(state, content) {
    content.parent.content.push(content.leaf)
  },
  // param content = {item, parent}
  REMOVE_LEAF_TO_STRUCTURE(state, content) {
    const index = content.parent.content.indexOf(content.item);
    if (index > -1) {
      content.parent.content.splice(index, 1);
    }
  },
  // @params: nameObject = {oldName, newName, type, item}
  RENAME_GROUP(state, nameObject) {
    nameObject.item.name = nameObject.newName
  },
  // @params: group = {parent, index, type}
  ADD_GROUP_TO_STRUCTURE(state, group) {
    if (!group.parent) {
      state.currentLPath.content.splice(group.index, 0, {
        name: "",
        content_type: group.type,
        content: []
      });
    } else {
      group.parent.content.splice(group.index, 0, {
        name: "",
        content_type: group.type,
        content: [],
      });
    }
  },
  // param content = {parent, index}
  REMOVE_GROUP_OF_STRUCTURE(state, group) {
    if (!group.parent) {
      state.currentLPath.content.splice(group.index, 1);
    } else {
      group.parent.content.splice(group.index, 1);
    }
  },
  UPDATE_CONTENT_ORDER(state, {
    item,
    newContent
  }) {
    if (item) {
      item.content = newContent
    } else {
      state.currentLPath = {
        ...state.currentLPath,
        content: newContent
      }
    }
  },
  ADD_PASS_TO_LPATH_PASSES(state, pass) {
    state.currentLPath.direct_passes.push(pass.id);
  },
  REMOVE_PASS_FROM_LPATH_PASSES(state, pass) {
    const index = state.currentLPath.direct_passes.findIndex(id => id === pass.id)
    state.currentLPath.direct_passes.splice(index, 1);
  }
}

export default mutations

